var n;

function zoom(){
    
  $('.zoomContainer').remove();

  $('.SliderFade.large ul li.active img').elevateZoom({
    zoomType: "inner",
    cursor: "crosshair",
    zoomWindowFadeIn: 300,
    zoomWindowFadeOut: 300
  });
  
};

function resizedw(){
  $('.zoomContainer').remove();
  zoom();
}

window.onresize = function() {
    clearTimeout(n);
    n = setTimeout(function() {
        resizedw();
    }, 300);
};

$( window ).load(function() {
    zoom();
});